import { InjectionToken } from '@angular/core';

export const TREO_APP_CONFIG = new InjectionToken<any>('TREO_APP_CONFIG');
